interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  disabled?: boolean;
  fit?: boolean;
  onClick?: () => void;
  red?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export default function GlassMonsterButton({
  children,
  colorSwap,
  fit,
  onClick,
  red,
  type = 'submit',
  disabled
}: Props) {
  if (colorSwap) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={`bg-monsterPurple/50 hover:bg-monsterPurpleHover/50 ${fit ? 'w-fit' : 'w-full'} border-monsterPurple/50 hover:border-monsterPurpleHover/50 nice-hover-no-shadow nice-pop cursor-pointer rounded-lg border px-3 py-2 text-center font-bold text-white backdrop-blur-sm transition-all duration-300 ease-in-out`}
      >
        {children}
      </button>
    );
  }

  if (red) {
    return (
      <button
        disabled={disabled}
        onClick={onClick}
        type={type}
        className={`${fit ? 'w-fit' : 'w-full'} nice-hover-no-shadow nice-pop cursor-pointer rounded-lg border border-red-600/50 bg-red-600/50 px-3 py-2 text-center font-bold text-white backdrop-blur-sm transition-all duration-300 ease-in-out hover:border-red-800/50 hover:bg-red-800/50`}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`bg-monsterGreen/50 hover:bg-monsterGreenHover/50 hover:border-monsterGreenHover/50 border-monsterGreen/50 nice-hover-no-shadow nice-pop border text-white ${fit ? 'w-fit' : 'w-full'} cursor-pointer rounded-lg px-3 py-2 text-center font-bold transition-all duration-300 ease-in-out`}
    >
      {children}
    </button>
  );
}
